import styled from 'styled-components'

import theme, { breakpoint } from 'style/theme'

export default styled.div`
  position: relative;

  .image-person-block {
    position: absolute;
    top: -148px;
    left: 80px;
    .image-person {
    }
    .image-arm {
      position: absolute;
      left: -7px;
      bottom: 9px;
      z-index: 2;
    }
  }

  .content {
    position: relative;
    padding: 30px 0;
    border-radius: 25px;
    background-color: #eae7e4;

    .title {
      text-align: center;
    }

    .portfolio-content {
      margin-top: 30px;
      margin-bottom: 20px;
      padding: 0 100px;

      .swiper-button-custom {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        z-index: 1;
        padding: 10px;
        cursor: pointer;
        width: 50px;
        height: 50px;
        border-radius: 100%;
        background: ${theme.primaryRed};
        display: flex;
        align-items: center;
        justify-content: center;

        &.swiper-button-custom-prev {
          left: 30px;
          img {
            transform: rotate(180deg);
          }
        }
        &.swiper-button-custom-next {
          right: 30px;
        }
      }

      .swiper-slide {
        padding: 2px 0 15px 0;
        border-radius: 20px;
      }

      .portfolio-item {
        border-radius: 20px;
        overflow: hidden;
        background: ${theme.white};
        box-shadow: 0 10px 15px 0 rgba(168, 150, 120, 0.16);

        .image-portfolio {
          img {
            aspect-ratio: 1801 / 1201;
          }
        }

        .info-block {
          padding: 10px 22px;

          .detail {
            margin: 15px 0;
            color: ${theme.mediumGray};
            height: 66px;
          }
          .read-more {
            color: ${theme.primaryRed};
          }
        }
      }
    }

    .button-block {
      display: flex;
      align-items: center;
      justify-content: center;
      button {
        box-shadow: 0 0 20px 0 rgba(226, 64, 54, 0.2);
      }
    }
  }

  @media (max-width: ${breakpoint.lg}) {
    .content {
      .portfolio-content {
        .swiper {
          padding-bottom: 0;
        }
      }
    }
  }

  @media (max-width: ${breakpoint.md}) {
    .image-person-block {
      display: none;
    }

    .content {
      border-radius: 0;
      background-color: transparent;

      .portfolio-content {
        padding: 0 15px;
        .swiper {
          padding-bottom: 24px;
        }
        .swiper-button-custom {
          display: none;
        }
      }
    }
  }
`
